/* eslint-disable react/display-name */
import classNames from "classnames";
import React from "react";

export const ExternalLinkSelection: React.FC<{
  title?: string;
  className?: string;
  links: ReadonlyArray<Queries.ExternalLinkFragment>;
  onClick?: () => void;
}> = ({ title, links, className = "", onClick }) => {
  return (
    <div className={classNames(className, "space-y-10px")}>
      {title && (
        <h3 className={classNames("h7", "text-lazer", "mb-10px")}>{title}</h3>
      )}
      {links?.map((externalLink, i) => {
        return (
          <a
            href={externalLink.url}
            key={i}
            className={classNames("block text-cotton")}
            onClick={onClick}
          >
            {externalLink.title}
          </a>
        );
      })}
    </div>
  );
};
